import type { PatientCommunicationTypeId } from '../../services/api/types.gen';

// The 30-Day Summary communication type (ROG-2145). Byte-identical to the
// backend enum value `PatientCommunicationTypeId.THIRTY_DAY_SUMMARY = "30-Day
// Summary"` (ASCII hyphen). The generated `PatientCommunicationTypeId` union
// does not yet carry this member — it lands when `npm run generate-client`
// runs in Phase E — so the literal is asserted into the union here.
export const THIRTY_DAY_SUMMARY_COMMUNICATION_TYPE =
  '30-Day Summary' as PatientCommunicationTypeId;

/** All communication type values (aligned with external EMR). */
export const PATIENT_COMMUNICATION_TYPES: readonly PatientCommunicationTypeId[] =
  [
    'Patient Communication',
    'CLM Welcome Call',
    'Physician Communication',
    'POC Doc Clarification',
    'Telehealth DC Tracking',
    'Telehealth Discontinue/Return to Office',
    'Telehealth Pickup/Setup',
    'CJR Report',
    'CLM Recert Call',
    'Wound Consult',
    THIRTY_DAY_SUMMARY_COMMUNICATION_TYPE,
  ];
